import { OptionKey } from '@common-fe/common-fe';

import { Option, ValuesMap } from '@/common/types';

import { ReportTab, ReportTypeKeys } from '../report.types';
export const INFINITE_DATE = '9999-01-01';
export const PER_PAGE = 20;

export const SETUP_SCHEDULER_FOOTER_PORTAL_ID = 'SETUP_SCHEDULER_FOOTER_PORTAL_ID';
export interface ScheduledFormPayload {
  name: string;
  tab: ReportTab;
  type: ReportTypeKeys;
  startDate: string;
  endDate: string;
  cronString: string;
}
export interface ScheduledFiltersResponse {
  employer_id: number;
  employer_ids: number[];
  show_ssn: boolean;
  search_value: string;
  card_status_report_group_type: string;
  is_not_mailed: boolean;
  mailed_start_date: string;
  mailed_end_date: string;
  card_statuses: OptionKey[];
  employment_statuses: OptionKey[];
  cip_status_start_date: string;
  cip_status_end_date: string;
  account_statuses: OptionKey[];
  account_types: OptionKey[];
  enrollment_statuses: OptionKey[];
  cip_statuses: OptionKey[];
  claim_statuses: OptionKey[];
  claim_types: OptionKey[];
  claim_submit_start_date: string;
  claim_submit_end_date: string;
  claim_paid_start_date: string;
  claim_paid_end_date: string;
  invoice_id: number;
  invoice_close_start_date: string;
  invoice_close_end_date: string;
  forfeiture_report_group_type: string;
  plan_year_period: OptionKey[];
  plan_ids: OptionKey[];
  as_of_date?: string;
  contribution_start_date: string;
  contribution_end_date: string;
  transaction_start_date: string;
  transaction_end_date: string;
  claim_activity_date_range_type?: OptionKey;
}
export interface ScheduledReportPayload extends ScheduledFormPayload {
  id?: string;
  employerId?: string;
  employerIds?: string[];
  reportPlanIds?: OptionKey[];
  isEditMode?: boolean;
  isMultipleEmployer?: boolean;
  filterValues: Partial<ScheduledItemFilters>;
}

export const REPORT_TYPE_TITLES: ValuesMap<string> = {
  [ReportTypeKeys.CardStatus]: 'Card Status',
  [ReportTypeKeys.CIPStatus]: 'CIP Status',
  [ReportTypeKeys.ClaimsActivity]: 'Claims Activity',
  [ReportTypeKeys.PlanOmnibusBalance]: 'Plan Omnibus Balance',
  [ReportTypeKeys.ContributionInvoice]: 'Contribution Invoice',
  [ReportTypeKeys.EmployeeDemographic]: 'Employee Demographic',
  [ReportTypeKeys.Forfeiture]: 'End of Year',
  [ReportTypeKeys.HealthPlanEnrollment]: 'Health Plan Enrollment',
  [ReportTypeKeys.ParticipantActivity]: 'Participant Account Activity',
  [ReportTypeKeys.Payroll]: 'Payroll Contributions',
  [ReportTypeKeys.PrefundInvoiceCard]: 'Prefund Invoice',
  [ReportTypeKeys.ReplenishmentInvoice]: 'Replenishment Invoice',
  [ReportTypeKeys.UndeliverableAddress]: 'Undeliverable Mail',
  [ReportTypeKeys.DelinquentClaims]: 'Delinquent Claims',
};

export const REPORT_TYPE_OPTIONS = Object.keys(REPORT_TYPE_TITLES).map((key) => {
  const option: Option = {
    key: key,
    value: REPORT_TYPE_TITLES[key],
    title: REPORT_TYPE_TITLES[key],
  };
  return option;
});

export const MULTIPLE_EMPLOYERS_REPORT_TYPES: ReportTypeKeys[] = [
  ReportTypeKeys.CardStatus,
  ReportTypeKeys.CIPStatus,
  ReportTypeKeys.ClaimsActivity,
  ReportTypeKeys.ParticipantActivity,
  ReportTypeKeys.EmployeeDemographic,
  ReportTypeKeys.HealthPlanEnrollment,
  ReportTypeKeys.Payroll,
  ReportTypeKeys.DelinquentClaims,
  ReportTypeKeys.UndeliverableAddress,
];
export enum ScheduledReportStatus {
  Active = 'ACTIVE',
  Deactivated = 'DEACTIVATED',
}

export interface ScheduledItemFilters {
  employerId: string;
  employerIds?: string[];
  asDate?: Date | null;
  isSSNShowed: boolean;
  cardStatusReportGroupType: string;
  isNotMailed: boolean;
  cardStatuses: OptionKey[];
  accountStatuses: OptionKey[];
  accountTypes: OptionKey[];
  employmentStatuses: OptionKey[];
  enrollmentStatuses: OptionKey[];
  cipStatuses: OptionKey[];
  claimStatuses: OptionKey[];
  claimTypes: OptionKey[];
  forfeitureReportGroupType: OptionKey[];
  planYearPeriod: OptionKey[];
  reportPlanIds: OptionKey[];
  planIds: OptionKey[];
  planNames?: string[];
  invoiceId: string;

  activityDateRangeFor?: OptionKey | null;
}
export interface ScheduledReportItemPayload {
  id: string;
  name: string;
  reportType: ReportTypeKeys;
  cron: string;
  nextScheduledDate?: string;
  startDate?: string;
  endDate?: string;
  reportGroupType: ReportTab;
  status: ScheduledReportStatus;
  reportFilter: Partial<ScheduledItemFilters>;
}

export interface ScheduledReportInboxItemPayload {
  id: string;
  name: string;
  reportType: ReportTypeKeys;
  reportGroupType: ReportTab;
  generationDate: string;
  url: string;
  reportFilter: Partial<ScheduledItemFilters>;
}
